import { render, staticRenderFns } from "./RiskEarlyWarning.vue?vue&type=template&id=690d29a4&scoped=true&"
import script from "./RiskEarlyWarning.vue?vue&type=script&lang=js&"
export * from "./RiskEarlyWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d29a4",
  null
  
)

export default component.exports